import {
  getGlobalIdematHomeEnergy,
  getGlobalIdematPurchaseEnergy,
  getGlobalIdematInventoryChemical,
  getGlobalIdematSymbioticEnergy,
  getWaterSourceData,
} from "../../../../../apis/Dropdown";
import { getGasRefrigerant } from "../../../../../apis/Dropdown";
import { getSuppresantIndustrialData } from "../../../../../apis/Dropdown";
import { getInventoryBuildingData } from "../../../../../apis/Dropdown";
import { getInventoryMachineData } from "../../../../../apis/Dropdown";
import { getInventoryServiceData } from "../../../../../apis/Dropdown";
import { getInventoryPackagingData } from "../../../../../apis/Dropdown";
import { getInventoryIngoingPackagingDropdown } from "../../../../../apis/Dropdown";
import { getFuelVehicleDropdown } from "../../../../../apis/Dropdown";
import { getTransportDeliveriesData } from "../../../../../apis/Dropdown";
import { getInventoryMaterialData } from "../../../../../apis/Dropdown";
import { getTravelCommuteData } from "../../../../../apis/Dropdown";
import { getWasteMaterial } from "../../../../../apis/Dropdown";
import {
  getProcessingIntermediateDropdown,
  getProcessingFinalTreatmentDropdown,
} from "../../../../../apis/Dropdown";
const getDropdownOptions = async (
  category = null,
  subcategory = null,
  businessId = null,
  t
) => {
  const createDropdownItem = (id, name, value, type, unit, typeDB, key) => ({
    id,
    name: t(name),
    value: t(value),
    type: t(type),
    unit,
    typeDB,
    key,
  });

  const dropdownOptions = {
    waterLocations: [
      createDropdownItem(
        1,
        "WASTE_WATER",
        "WASTE_WATER",
        "WASTE_WATER",
        "kg",
        "waste_water",
        "WASTE_WATER"
      ),
      createDropdownItem(
        2,
        "RAIN_WATER",
        "RAIN_WATER",
        "RAIN_WATER",
        "L",
        "rain_water",
        "RAIN_WATER"
      ),
      createDropdownItem(
        3,
        "MELT_WATER",
        "MELT_WATER",
        "MELT_WATER",
        "L",
        "melt_water",
        "MELT_WATER"
      ),
      createDropdownItem(
        4,
        "DRAINAGE_WATER",
        "DRAINAGE_WATER",
        "DRAINAGE_WATER",
        "L",
        "drainage_water",
        "DRAINAGE_WATER"
      ),
      createDropdownItem(
        5,
        "WELL_WATER",
        "WELL_WATER",
        "WELL_WATER",
        "L",
        "well_water",
        "WELL_WATER"
      ),
    ],
    surplusEnergy: [
      createDropdownItem(
        1,
        "WASTE_STEAM",
        "WASTE_STEAM",
        "WASTE_STEAM",
        "MJ",
        "steam",
        "WASTE_STEAM"
      ),
      createDropdownItem(
        2,
        "WASTE_HEAT",
        "WASTE_HEAT",
        "WASTE_HEAT",
        "kWh",
        "heat",
        "WASTE_HEAT"
      ),
      createDropdownItem(
        3,
        "WASTE_COOLING",
        "WASTE_COOLING",
        "WASTE_COOLING",
        "kWh",
        "cooling",
        "WASTE_COOLING"
      ),
    ],
    regVeh: [
      createDropdownItem(1, "TRUCK", "TRUCK", "TRUCK", null, "truck", "TRUCK"),
      createDropdownItem(
        2,
        "PASSENGER_CAR",
        "PASSENGER_CAR",
        "PASSENGER_CAR",
        null,
        "passenger_car",
        "PASSENGER_CAR"
      ),
      createDropdownItem(
        3,
        "MOTORBIKE",
        "MOTORBIKE",
        "MOTORBIKE",
        null,
        "motorbike",
        "MOTORBIKE"
      ),
      createDropdownItem(4, "BUS", "BUS", "BUS", null, "bus", "BUS"),
      createDropdownItem(5, "VAN", "VAN", "VAN", null, "van", "VAN"),
      createDropdownItem(6, "PLANE", "PLANE", "PLANE", null, "plane", "PLANE"),
      createDropdownItem(7, "SHIP", "SHIP", "SHIP", null, "ship", "SHIP"),
    ],
    appliance: [
      { id: 1, name: t("Lamp"), value: t("Lamp") },
      { id: 2, name: t("Printer"), value: t("Printer") },
      { id: 3, name: t("Shredder"), value: t("Shredder") },
      { id: 4, name: t("Laptop"), value: t("Laptop") },
      { id: 5, name: t("Exstra screen"), value: t("Exstra screen") },
      { id: 6, name: t("Tablet"), value: t("Tablet") },
      {
        id: 7,
        name: t("Height adjustable table"),
        value: t("Height adjustable table"),
      },
      { id: 8, name: t("Smartphone"), value: t("Smartphone") },
      { id: 9, name: t("Desktop computer"), value: t("Desktop computer") },
    ],
    waterSymbiotic: [
      createDropdownItem(
        1,
        "DRINKING_WATER_EUROPE",
        "DRINKING_WATER_EUROPE",
        "DRINKING_WATER_EUROPE",
        "kg",
        "europe_drinking_water",
        "DRINKING_WATER_EUROPE"
      ),
      createDropdownItem(
        2,
        "INDUSTRIAL_REVERSE_OSMOSIS",
        "INDUSTRIAL_REVERSE_OSMOSIS",
        "INDUSTRIAL_REVERSE_OSMOSIS",
        "kg",
        "osmosis",
        "INDUSTRIAL_REVERSE_OSMOSIS"
      ),
    ],
  };

  // Define API calls
  const apiCalls = {
    mainEnergy: {
      api: getGlobalIdematPurchaseEnergy,
      setter: "setDropdown",
    },
    homeEnergy: {
      api: getGlobalIdematHomeEnergy,
      setter: "setDropdown",
    },
    symbioticEnergy: {
      api: getGlobalIdematSymbioticEnergy,
      setter: "setDropdown",
    },
    waterEquipment: {
      api: getWaterSourceData,
      setter: "setDropdownWaterData",
    },
    gasRefrigerant: {
      api: getGasRefrigerant,
      setter: "setDropdown",
    },
    gasType: { api: getSuppresantIndustrialData, setter: "setDropdown" },
    buildingData: {
      api: getInventoryBuildingData,
      setter: "setDropdownData",
    },
    machinery: { api: getInventoryMachineData, setter: "setDropdownData" },
    service: { api: getInventoryServiceData, setter: "setDropdownData" },
    packaging: {
      api: getInventoryPackagingData,
      setter: "setDropdownData",
    },
    material: {
      api: getInventoryIngoingPackagingDropdown,
      setter: "setInventoryDropdown",
      params: { businessId },
    },
    chemical: {
      api: getGlobalIdematInventoryChemical,
      setter: "setDropdown",
    },
    fuel: { api: getFuelVehicleDropdown, setter: "setDropdownData" },
    transport: {
      api: getTransportDeliveriesData,
      setter: "setDropdownData",
    },
    inventory: {
      api: getInventoryMaterialData,
      setter: "setDropdownData",
    },
    means: { api: getTravelCommuteData, setter: "setDropdown" },
    wasteMethod: { api: getWasteMaterial, setter: "setDropdown" },
    processingSold: {
      api: getProcessingIntermediateDropdown,
      setter: "setDropdown",
    },
    processingFinalTreatment: {
      api: getProcessingFinalTreatmentDropdown,
      setter: "setDropdown",
    },
  };

  const makeApiCall = (apiCall) => {
    const { api, setter, params } = apiCall;
    return new Promise((resolve) => {
      api({
        [setter]: (data) => {
          resolve(data);
        },
        ...params,
      });
    });
  };

  const getCategoryInitials = (category) => {
    if (!category) return null;

    const initials = category
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase())
      .join("");

    return initials;
  };

  const getCategoryOptions = async (cat) => {
    const categoryInitials = getCategoryInitials(cat);

    switch (categoryInitials) {
      case "BTAHS": // Business Travel and Hotel Stays
        return await makeApiCall(apiCalls.means);
      case "RV": // Registered Vehicle
        return dropdownOptions.regVeh;
      case "FV": // Fuel Vehicle
      case "OV": // Other Vehicle
        return await makeApiCall(apiCalls.fuel);
      case "IT": // Ingoing Transport
      case "OT": // Outgoing Transport
        return await makeApiCall(apiCalls.transport);
      case "I": // Inventory
        return await makeApiCall(apiCalls.inventory);
      case "EC": // Employee Commute
        return await makeApiCall(apiCalls.means);
      case "R": // Remote
        return dropdownOptions.appliance;
      case "SR": // Surplus Resources
        return await makeApiCall(apiCalls.wasteMethod);
      default:
        return null;
    }
  };

  const getSubcategoryOptions = async (subcat) => {
    switch (subcat) {
      case t("MAINS_INPUT"):
        return apiCalls.mainEnergy;
      case t("HOME_INPUT"):
        return apiCalls.homeEnergy;
      case t("SYMBIOTIC_INPUTS"):
        return apiCalls.symbioticEnergy;
      case t("WATER_USAGE"):
        return [
          {
            value: t("DRINKING_WATER_EUROPE"),
            title: t("DRINKING_WATER_EUROPE"),
            name: t("DRINKING_WATER_EUROPE"),
          },
        ];
      case t("WATER_FOUND_LOCATION"):
      case t("WATER_SYMBIOTIC_INPUT"):
        return dropdownOptions.waterSymbiotic;
      case t("WATER"):
        return dropdownOptions.waterLocations;
      case t("EQUIPMENT_LOCATION"):
        return await makeApiCall(apiCalls.waterEquipment);
      case t("REFRIGERATION_INPUTS"):
        return await makeApiCall(apiCalls.gasRefrigerant);
      case t("INDUSTRIAL_GAS_INPUTS"):
      case t("SUPPRESSANT_INPUTS"):
        return await makeApiCall(apiCalls.gasType);
      case t("INV_BUILDINGS"):
        return await makeApiCall(apiCalls.buildingData);
      case t("INV_VEHICLE"):
        return [];
      case t("MACHINERY"):
        return await makeApiCall(apiCalls.machinery);
      case t("PURCHASED_SERVICES"):
        return await makeApiCall(apiCalls.service);
      case t("INVENTORY_INGOING_PACKAGING"):
      case t("INVENTORY_PURCHASED_PACKAGING"):
        return await makeApiCall(apiCalls.packaging);
      case t("CHEMICALS"):
        return apiCalls.chemical;
      case t("TREATMENT_INGOING_PACKAGING"):
        return await makeApiCall(apiCalls.material);
      case t("SURPLUS_ENERGY"):
        return dropdownOptions.surplusEnergy;
      case t("PROCESSING_NO_DATA_TITLE"):
        return dropdownOptions.processingSold;
      case t("PROCESSING_DATA_TITLE"):
        return dropdownOptions.processingSold;
      case t("WASTE_GEN_TITLE"):
        return dropdownOptions.processingFinalTreatment;
      default:
        return null;
    }
  };

  if (category && !subcategory) {
    return getCategoryOptions(category);
  } else if (!category && subcategory) {
    return getSubcategoryOptions(subcategory);
  } else if (category && subcategory) {
    const subcategoryOptions = await getSubcategoryOptions(subcategory);
    if (subcategoryOptions !== null) {
      return subcategoryOptions;
    }

    const categoryOptions = await getCategoryOptions(category);
    return categoryOptions;
  } else {
    return null;
  }
};

export default getDropdownOptions;
